export default "__VITE_ASSET__CWMwjoOa__"